import utils from '../../util/Util';
import consts from '../../util/Consts';
import axios from 'axios';

const ACTION_STATUSES = ['START', 'SUCCESS', 'ERROR'];

var defaultHandlers = {

  START: function (state) {
    return Object.assign({}, state, { isFetching: true, error: null });
  },

  SUCCESS: function (state, action) {
    if (action.options.start && !action.isFetching) {
      var allItems = [];
      allItems = action.options.start > 0 && state.data && action.options.isList ? state.data.records : [];
      action.json.records = allItems.concat(action.json.records);
      action.isFetching = true;
    }
    return Object.assign({}, state, { data: action.json, isFetching: false, type: action.type, error: null });
  },

  ERROR: function (state, action) {
    let errorMessage = utils.getErrorInfo(action);
    return Object.assign({}, state, { isFetching: false, error: errorMessage, data: null });
  }
};


export default class AjaxAction {
  constructor(options) {
    Object.assign(this, options);
    let requestType = options.requestType;
    let actionTypes = {};
    let actions = {};
    let statuses = [].concat(ACTION_STATUSES);

    for (const status of statuses) {
      var action = requestType + '_' + status
      actionTypes[requestType + '_' + status] = action;
      actions[status] = action;
    }
    this.actionTypes = actionTypes;
    this.actions = actions;
    this.reducer = this._createReducer(options);
  }

  _createReducer(options) {
    var requestType = options.requestType;

    var actions = options.actions || ACTION_STATUSES;

    var validActions = [];

    actions.forEach((action) => {
      var actionName = requestType + '_' + action;
      validActions.push(actionName);
    });

    for (var o in options.otherHandlers) {
      validActions.push(requestType + '_' + o);
    }

    let parser = this._createDefaultParser(options, actions);

    return function (state = { isFetching: false, data: null }, action) {
      if (validActions.indexOf(action.type) > -1) {
        return Object.assign({}, state, parser(state, action));
      }
      return state;
    }
  }

  _createDefaultParser(options, actions) {

    let customHandlers = Object.assign({}, defaultHandlers, options.handlers, options.otherHandlers);

    let handlerMap = {};

    for (var action in customHandlers) {
      var key = options.requestType + '_' + action;
      handlerMap[key] = customHandlers[action];
    };

    return function (state = { isFetching: false, data: {} }, action) {
      if (typeof handlerMap[action.type] === 'function') {
        return handlerMap[action.type](state, action, options);
      } else {
        return state;
      }
    }
  }

  request(options, id, method) {
    return (dispatch) => {
      return dispatch(this._fetch(options, id, method))
    }
  }

  _onStart(options) {
    return {
      type: this.actions.START,
      options
    }
  }

  _onSuccess(options, json) {
    return {
      type: this.actions.SUCCESS,
      options,
      json,
      receivedAt: Date.now()
    }
  }

  _onFailure(options, response) {
    return {
      type: this.actions.ERROR,
      options,
      response,
      receivedAt: Date.now()
    }
  }

  _fetch(options, id, type) {
    var me = this;
    if (me.lastFetch) {
      me.lastFetch.cancel();
    }
    var url = this.url;

    if (id || id === 0) {
      url = url + '?' + id;
    }
    url = new URL(url)

    return dispatch => {
      dispatch(me._onStart(options))

      let fetchOption = {
        method: type ? type : 'POST',
        ...Object.assign({}, type && type === "GET" ? {} :
          { body: options ? JSON.stringify(options) : JSON.stringify(options) })
      };

      if (type === "GET") {
        Object.keys(options).forEach(key => url.searchParams.append(key, options[key]))
      }
      fetchOption.headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }

      let UserData = JSON.parse(sessionStorage.getItem(consts.sessionVariables.UserData));
      let token = UserData?.token;

      if (token) fetchOption.headers.Authorization = 'Bearer ' + token;

      let axiosReq = {
        method: type ? type : 'POST',
        url: url,
        headers: fetchOption.headers
      }

      if (type !== 'GET') {
        axiosReq.data = options;
      }
      
      axios(axiosReq)
        .then(function (response) {
          if (response.status === 200) {
            dispatch(me._onSuccess(options, response.data));
          }
        }).catch(error => {
          dispatch(me._onFailure(options, error.message));

          if (error.response.status === 401) {
            sessionStorage.clear();
            window.location.replace("/");
          }
        });
    };
  }
}